import { render, staticRenderFns } from "./activityCard.vue?vue&type=template&id=36c187f1&scoped=true"
import script from "./activityCard.vue?vue&type=script&lang=ts"
export * from "./activityCard.vue?vue&type=script&lang=ts"
import style0 from "./activityCard.vue?vue&type=style&index=0&id=36c187f1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../soccer/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c187f1",
  null
  
)

export default component.exports